<template>
    <button class="button button--share" @click="shareClicked">
        <div class="icon"></div>
        <span>Share</span>
    </button>
</template> 
<script>
export default {
    methods: {
        shareClicked() {
            this.location = window.location.href
            this.openMail();
        },
        openMail() {
            if(location)
                window.open(this.composedEmail, '_self');
        },
    },
    data() {
        return {
            subject: 'Look at this page from Interflon',
            newLineChar: '%0D%0A',
            generalBody: `Take a look:`,
            location: undefined
        }
    },
    computed: {
        composedEmail() {
            let body = this.generalBody + this.newLineChar + location;
            return `mailto:?subject=${this.subject}&body=${body}`;
        }
    }
}
</script>
<style lang="scss" scoped>
.button {
    position: absolute;
    bottom: 50px;
    left: 274px;
    z-index: 2;
}
</style>